<template>
  <div class="dev-tools-wrapper">
    <div class="custom-wrapper">
      <h3>AES 加密</h3>
      <el-form label-position="top" ref="aesForm" :rules="rules" :model="aesForm">
        <el-form-item label="秘钥" prop="secret">
          <el-input v-model="aesForm.secret"></el-input>
        </el-form-item>
        <el-form-item label="加解密内容" prop="content">
          <el-input
            type="textarea"
            :autosize="{ minRows: 5, maxRows: 10}"
            v-model="aesForm.content"></el-input>
        </el-form-item>
        <el-form-item style="display: flex; justify-content: center;">
          <el-button type="danger" @click="onEncodeConfirm">加密</el-button>
          <el-button @click="onDecodeConfirm">解密</el-button>
        </el-form-item>
      </el-form>
      <div class="encode-result" v-show="aesResult !== ''">
        <h2>加密结果：</h2>
        <p style="word-break: break-word;">
          {{ aesResult }}
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import { aesEncode, aesDecode } from '@/utils/crypto'

import { mapGetters } from 'vuex'

export default {
  name: 'DevTools',
  data () {
    return {
      aesToolDialogVisible: false,

      aesForm: {
        secret: '',
        content: ''
      },
      rules: {
        secret: [
          { required: true, message: '请输入加密秘钥', trigger: 'blur' },
          { type: 'string', min: 32, max: 32, message: '秘钥长度必须为 32 位', trigger: 'blur' }
        ],
        content: [
          { required: true, message: '请输入密码', trigger: 'blur' }
        ]
      },
      aesResult: ''
    }
  },
  computed: {
    ...mapGetters('opUser', [
      'hasRes'
    ])
  },
  methods: {
    onEncodeConfirm () {
      this.$refs['aesForm'].validate(valid => {
        if (valid) {
          this.aesResult = aesEncode(this.aesForm.secret, this.aesForm.content)
        } else {
          return false
        }
      })
    },
    onDecodeConfirm () {
      this.$refs['aesForm'].validate(valid => {
        if (valid) {
          try {
            this.aesResult = aesDecode(this.aesForm.secret, this.aesForm.content)
          } catch (err) {
            this.$message({
              type: 'error',
              message: '解密失败，请检查你的秘钥'
            })
          }

          if (this.aesResult === '') {
            this.$message({
              type: 'error',
              message: '解密失败，请检查你的秘钥'
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../../assets/sass/base";

.dev-tools-wrapper {
  h3 {
    color: $primaryColor;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/op/factory/DevTools.vue